import {logAction} from "../../../logging/logEvent";
import {SortState} from "../../sorting/SortState";
import {addTimeOpen, addTimeOpenInPeriod} from "../idea/timeOpenCalculator";
import {Clock} from "js-joda";

export const INITIAL_STATE = {
    loading: true,
    content: null,
    ideasView: "open-ideas",
    rankingsView: "my-team",
    openIdeasSort: new SortState("kpiValue", "desc", false),
    closedIdeasSort: new SortState("kpiValue", "desc", false),
    previousIdeasSort: new SortState("kpiValue", "desc", false),
    rankingsSort: new SortState("rank", null),
    scrollToAuthor: true
};

export function processIdeas(ideas) {
    if (!ideas) return ideas;

    return ideas
        .map(idea => addTimeOpen(idea, Clock.systemDefaultZone()))
        .map(idea => idea.performanceStart ? addTimeOpenInPeriod(idea, Clock.systemDefaultZone()) : idea);
}

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case "SUBSCRIPTION_DATA_ARRIVED/PORTFOLIO_AUTHOR":
            const content = {
                ...action.payload,
                openIdeas: processIdeas(action.payload.openIdeas),
                closedIdeas: processIdeas(action.payload.closedIdeas),
                previousIdeas: processIdeas(action.payload.previousIdeas),
            };
            return {...state, loading: false, content: content};
        case "PORTFOLIO_AUTHOR_ACTIONS/RESET":
            return INITIAL_STATE;
        case "PORTFOLIO_AUTHOR_ACTIONS/CHANGE_IDEAS_VIEW":
            return {...state, ideasView: action.payload};
        case "PORTFOLIO_AUTHOR_ACTIONS/CHANGE_RANKINGS_VIEW":
            return {...state, rankingsView: action.payload, scrollToAuthor: true};
        case "PORTFOLIO_AUTHOR_ACTIONS/SORT_OPEN_IDEAS_BY": {
            const {sortField, descendingFirst} = action.payload;
            const openIdeasSort = state.openIdeasSort.requestSortBy(sortField, descendingFirst);
            return {...state, openIdeasSort};
        }
        case "PORTFOLIO_AUTHOR_ACTIONS/SORT_CLOSED_IDEAS_BY": {
            const {sortField, descendingFirst} = action.payload;
            const closedIdeasSort = state.closedIdeasSort.requestSortBy(sortField, descendingFirst);
            return {...state, closedIdeasSort};
        }
        case "PORTFOLIO_AUTHOR_ACTIONS/SORT_PREVIOUS_IDEAS_BY": {
            const {sortField, descendingFirst} = action.payload;
            const previousIdeasSort = state.previousIdeasSort.requestSortBy(sortField, descendingFirst);
            return {...state, previousIdeasSort};
        }
        case "PORTFOLIO_AUTHOR_ACTIONS/SORT_RANKINGS_BY": {
            const {sortField, descendingFirst} = action.payload;
            const rankingsSort = state.rankingsSort.requestSortBy(sortField, descendingFirst);
            return {...state, rankingsSort};
        }
        case "PORTFOLIO_AUTHOR_ACTIONS/SELECT_AUTHOR": {
            return {...state, scrollToAuthor: false}
        }
        default:
            return state;
    }
}

export function reset() {
    return {type: "PORTFOLIO_AUTHOR_ACTIONS/RESET"};
}

export function sortOpenIdeasBy(sortField, descendingFirst = true) {
    return {type: "PORTFOLIO_AUTHOR_ACTIONS/SORT_OPEN_IDEAS_BY", payload: {sortField, descendingFirst}};
}

export function sortClosedIdeasBy(sortField, descendingFirst = true) {
    return {type: "PORTFOLIO_AUTHOR_ACTIONS/SORT_CLOSED_IDEAS_BY", payload: {sortField, descendingFirst}};
}

export function sortPreviousIdeasBy(sortField, descendingFirst = true) {
    return {type: "PORTFOLIO_AUTHOR_ACTIONS/SORT_PREVIOUS_IDEAS_BY", payload: {sortField, descendingFirst}};
}

export function sortRankingsBy(sortField, descendingFirst = true) {
    return {type: "PORTFOLIO_AUTHOR_ACTIONS/SORT_RANKINGS_BY", payload: {sortField, descendingFirst}};
}

export function selectAuthor() {
    return {type: "PORTFOLIO_AUTHOR_ACTIONS/SELECT_AUTHOR"}
}

export default dispatch => ({
    changeIdeasView(ideasView) {
        logAction({type: "PORTFOLIO_AUTHOR_IDEAS_VIEW_CHANGED", ideasView});
        dispatch({type: "PORTFOLIO_AUTHOR_ACTIONS/CHANGE_IDEAS_VIEW", payload: ideasView});
    },
    changeRankingsView(rankingsView) {
        logAction({type: "PORTFOLIO_AUTHOR_RANKINGS_VIEW_CHANGED", rankingsView});
        dispatch({type: "PORTFOLIO_AUTHOR_ACTIONS/CHANGE_RANKINGS_VIEW", payload: rankingsView});
    },
    reset() {
        dispatch(reset());
    },
    sortOpenIdeasBy(sortField, descendingFirst) {
        dispatch(sortOpenIdeasBy(sortField, descendingFirst));
    },
    sortClosedIdeasBy(sortField, descendingFirst) {
        dispatch(sortClosedIdeasBy(sortField, descendingFirst));
    },
    sortPreviousIdeasBy(sortField, descendingFirst) {
        dispatch(sortPreviousIdeasBy(sortField, descendingFirst));
    },
    sortRankingsBy(sortField, descendingFirst) {
        dispatch(sortRankingsBy(sortField, descendingFirst));
    },
    selectAuthor() {
        dispatch(selectAuthor());
    }
});
